module.exports = __webpack_public_path__ + "img/744.ee34a5d0.jpg";